<template>
<div class="chapter">
<div class="inner_page">
<div class="Basic-Text-Frame" id="_idContainer016">
<p class="Author-tp">Anthony Evans</p>
<p class="Title-tp">The School Run<br/>Has Never Been<br/>So Fun!</p>
<div class="_idGenObjectLayout-1">
<div class="Imprint" id="_idContainer000">
<img alt="" class="_idGenObjectAttribute-1" role="presentation" src="image/Logo-for-titlepages-new-CMYK-transparent.jpg"/>
</div>
</div>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 9781035821600_EPUB.vue?0cf5ea54